module.exports = __webpack_public_path__ + "img/reimbursement-selected.f7fa0035.svg";